import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const NEW_JOB_THRESHOLD_HOURS = 48;

export const isNewJob = (createdAt: string): boolean =>
  dayjs().diff(dayjs(createdAt), 'hour') < NEW_JOB_THRESHOLD_HOURS;

export const getPostedAgo = (createdAt: string): string => `Posted ${dayjs(createdAt).fromNow()}`;

// Marks the point right after sentence-ending punctuation + whitespace, so the string can be
// split there without needing lookbehind (`(?<=...)`), which throws a SyntaxError at
// script-parse time on Safari/iOS below 16.4 - taking down the whole bundle this ships in, not
// just this function. Uses a control character that can't otherwise appear in job description
// text as the split point.
const SENTENCE_BOUNDARY = '\u0000';

export const getJobHighlights = (text?: string, max = 3): string[] => {
  if (!text) {
    return [];
  }
  return text
    .replace(/([.!?])\s+/g, `$1${SENTENCE_BOUNDARY}`)
    .split(SENTENCE_BOUNDARY)
    .map(sentence => sentence.trim())
    .filter(Boolean)
    .slice(0, max);
};
